export const closeMobileMenu = () => {
  document.body.classList.remove('mobile-menu-opened')
  document.body.style.paddingRight = ''

  const mobileDropdown = document.querySelector('.navigation')
  if (mobileDropdown) {
    mobileDropdown.style.paddingRight = ''
  }
}
